import React, { useState, useMemo } from 'react';
import { useLanguage } from '../context/LanguageContext';
import ProjectCard from '../components/ProjectCard';

const Projects = () => {
  const { t, projects } = useLanguage();
  const [filter, setFilter] = useState('All');

  const allProjects = useMemo(() => {
    return Object.values(projects).sort((a, b) => {
      if (a.type === 'Work' && b.type !== 'Work') return -1;
      if (a.type !== 'Work' && b.type === 'Work') return 1;
      return 0;
    });
  }, [projects]);

  const filteredProjects = useMemo(() => {
    if (filter === 'All') return allProjects;
    return allProjects.filter((p) => p.type === filter);
  }, [filter, allProjects]);

  const projectCounts = {
    All: allProjects.length,
    School: allProjects.filter((p) => p.type === 'School').length,
    Work: allProjects.filter((p) => p.type === 'Work').length,
  };

  const filterLabels = {
    All: t('allProjects'),
    School: t('schoolProjects'),
    Work: t('workProjects'),
  };

  const visibleFilters = Object.entries(projectCounts).filter(([, count]) => count > 0);

  return (
    <>
      <section className="page-head">
        <div className="wrap">
          <h1 className="page-title">{t('projectsTitle')}</h1>
          <p className="page-sub">{t('projectsSubtitle')}</p>

          <div className="filters" role="group" aria-label={t('projectsTitle')}>
            {visibleFilters.map(([type, count]) => (
              <button
                key={type}
                type="button"
                className="filter"
                aria-pressed={filter === type}
                onClick={() => setFilter(type)}
              >
                {filterLabels[type]} ({count})
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="index-section">
        <div className="wrap">
          <ul className="index">
            {filteredProjects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default Projects;
